import { Text } from "@krea/customer-features/shared-components/text";
import twMerge from "@krea/customer-features/utils/tailwind-utils";

const BidsListItemMobileOtherInfo = ({
  title,
  value,
  className,
}: {
  title: string;
  value: string;
  className?: string;
}) => {
  return (
    <dl className={twMerge("tw-flex tw-justify-between tw-m-0", className)}>
      <Text
        htmlTag="dt"
        size="md"
        className="tw-mb-1 tw-font-normal tw-text-gray-600"
      >
        {title}
      </Text>
      <Text
        htmlTag="dd"
        size="md"
        className="tw-m-0 tw-font-bold tw-text-black"
      >
        {value}
      </Text>
    </dl>
  );
};

export default BidsListItemMobileOtherInfo;
